'use strict';

import app from '../../ngmodule';
import './style.scss';
import { ShowFacilityStructureTypes } from '../../../services/facility-structure-helper';

app.component('questionTasklistTaskTile', {

  template: require('./template.html').default,
  bindings: {
    'task': '<',
    'presented': '<'
  },

  controller: ["TaskListUserInterfaceType", "webServiceUrl", "facilityStructureHelper", function (TaskListUserInterfaceType, webServiceUrl, facilityStructureHelper) {
    this.UserInterfaceType = TaskListUserInterfaceType;
    this.url = webServiceUrl;

    let facilityStructures = null;
    facilityStructureHelper.getFacilityStructures().then((result) => {
      facilityStructures = result;
    });

    // LUCIFER-1278 - Build a smart name for the site, zone, floor, building, facility 
    // By a smart name we mean we will omit the Facility name if there is only 1 facility, same for building (within 1 facility ofcourse), level etc
    let smartNameBySiteId = {};
    this.facilityStructureSmartName = function (site, minType) {
      if (minType == ShowFacilityStructureTypes.None || facilityStructures == null) {
        return "";
      }

      minType = minType == null ? ShowFacilityStructureTypes.Site : minType;

      let smartNameKey = site.id + " / " + minType;
      let smartName = smartNameBySiteId[smartNameKey];
      if (smartName == null) {
        let fs = facilityStructures.facilities;
        if (minType == ShowFacilityStructureTypes.Smart) {
          // Work out the structuretype that is our "smart" type 
          // ie, if we only have 1 Facility and 1 Building with 2 Floors then the smart name starts with "Floor 1" since there is only 1 building within 1 facility
          minType = ShowFacilityStructureTypes.Facility;
          while (fs != null && fs.length == 1) {
            minType++;
            fs = facilityStructures.byType[minType];
          }
        }

        let s = facilityStructures.findBySiteId(site.id);
        if (s != null) {
          let result = [];
          while (s != null) {
            // Note, it may not be a site, but probably is 
            if (s.StructureType >= minType) {
              if (s.StructureType == ShowFacilityStructureTypes.Site) {
                result.push(site.name);
              } else {
                result.push(s.Name);
              }
            }
            s = s.parent;
          }
          smartName = result.join(" / ");
        } else {
          smartName = site.name;
        }
        smartNameBySiteId[smartNameKey] = smartName;
      }
      return smartName;
    }

  }]
});